module.exports = __webpack_public_path__ + "static/img/guest6-big.e4d7d5d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/anniversary/pictures/guest6-big.jpg
// module id = uhwU
// module chunks = 0